/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { useState, useContext, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import FormInput from "../../../components/FormInput";
import { validationRules } from "../../../utils/validationRules";
import {
  createCreditCardLoan,
  getCreditCardLoanByEmail,
  getCreditCardLoanByMobile,
  getAllPincode,
  getAllStates,
  getAllCities,
} from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SelectInput from "../../../components/SelectInput";
import DropDownInput from "../../../components/DropDownInput";

const CreateCreditCardForm = () => {
  const { adminId, adminName } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const {
    handleSubmit,
    watch,
    trigger,
    formState: { errors, isValid },
  } = methods;

  const [mobileExists, setMobileExists] = useState(false);
  const [currentDate] = useState(new Date().toISOString().split("T")[0]);
  const [emailExists, setEmailExists] = useState(false);
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const steps = ["Personal Details", "Loan Details", "Upload Documents"];

  const handleStepChange = async (newStep) => {
    if (newStep > activeStep) {
      const isValid = await trigger();
      if (isValid) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }

        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }

        setActiveStep(newStep);
      }
    } else {
      setActiveStep(newStep);
    }
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setStates(availableStates);
        setFilteredStates(availableStates);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching states data:", error);
        setLoading(false);
      }
    };
    fetchStates();
  }, []);

  const stateOptions = filteredStates.map((state) => ({
    value: state.name,
    label: state.name,
  }));

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await getAllCities();
        citiesData.sort((a, b) => a.name.localeCompare(b.name));
        const tamilNaduCities = citiesData.filter(
          (city) => city.State_name === "Tamil Nadu"
        );

        const options = tamilNaduCities.map((city) => ({
          value: city.name,
          label: city.name,
        }));
        setCities(tamilNaduCities);
        setCityOptions(options);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);


  useEffect(() => {
    const fetchPinCode = async () => {
      try {
        const pincodeData = await getAllPincode();

        const tamilNaduStates = pincodeData.filter(
          (pincode) => pincode.state === "TAMIL NADU"
        );

        const uniquePincodes = new Set();
        const uniqueOptions = [];

        tamilNaduStates.forEach((pincode) => {
          if (!uniquePincodes.has(pincode.pincode)) {
            uniquePincodes.add(pincode.pincode);
            uniqueOptions.push({
              value: pincode.pincode,
              label: pincode.pincode,
            });
          }
        });
        uniqueOptions.sort((a, b) => a.value - b.value);
        setPincode(tamilNaduStates);
        setPincodeOptions(uniqueOptions);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchPinCode();
  }, []);

  const checkEmail = async (email) => {
    if (email) {
      try {
        const data = await getCreditCardLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    }
  };

  const checkMobile = async (mobile) => {
    if (mobile) {
      try {
        const data = await getCreditCardLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    }
  };

  const handleFileChange = (event) => {
    console.log(event.target.files);
  };

  const onSubmit = (data) => {
    data.created_by = adminName;
    data.created_id = adminId;

    data.status = data.status || "open";
    data.assigned_to = data.assigned_to || "";

    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (
        key === "pan" ||
        key === "aadhar" ||
        key === "photo" ||
        key === "bank_account" ||
        key === "itr" ||
        key === "gst_others"
      ) {
        if (data[key] && data[key].length > 0) {
          formData.append(key, data[key][0]);
        }
      } else {
        formData.append(key, data[key]);
      }
    });

    createCreditCardLoan(formData)
      .then((response) => {
        console.log("Loan application submitted:", response);
        navigate("/creditcardlist", {
          state: { successMessage: "CreditCard loan successfully created" },
        });
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message;

        if (typeof errorMessage === "string") {
          if (errorMessage.includes("Email already exists")) {
            toast.error("Email already exists. Please use a different email.");
          } else if (errorMessage.includes("Mobile number already exists")) {
            toast.error(
              "Mobile number already exists. Please use a different mobile number."
            );
          } else {
            console.error("Error submitting loan application:", errorMessage);
            toast.error("Failed to submit loan application. Please try again.");
          }
        } else {
          console.error("Error submitting loan application:", error);
          toast.error("Failed to submit loan application. Please try again.");
        }
      });
  };

  const email = watch("email");
  const mobile = watch("mobile");

  React.useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  React.useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  return (
    <div className="container">
      {activeStep === 0 && (
        <div className="edit-back-icon">
          <div
            className="edit-back-text"
            onClick={() => navigate("/creditcardlist")}
          >
            &lt; Go Back
          </div>
        </div>
      )}
      <h2 className="my-4">CreditCard</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="form-group">
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <div className="form-row">
                  <FormInput
                    name="name"
                    label="Name"
                    registerOptions={validationRules.name}
                    error={errors.name?.message}
                  />
                  <DropDownInput
                    name="gender"
                    label="Gender"
                    options={[
                      { value: "male", label: "Male" },
                      { value: "female", label: "Female" },
                      { value: "other", label: "Other" },
                    ]}
                    registerOptions={{ required: "Gender is required" }}
                    error={errors.gender?.message}
                  />
                </div>
                <div className="form-row">
                  <FormInput
                    name="date_of_birth"
                    label="Date of Birth"
                    type="date"
                    registerOptions={{
                      required: "Date of Birth is required",
                      validate: {
                        isOldEnough: (value) => {
                          const today = new Date();
                          const minAgeDate = new Date();
                          minAgeDate.setFullYear(today.getFullYear() - 21); // Minimum age is 18 years
                          return (
                            new Date(value) <= minAgeDate ||
                            "You must be at least 21 years old"
                          );
                        },
                        isNotFutureDate: (value) => {
                          return (
                            new Date(value) <= new Date() ||
                            "Date of Birth cannot be in the future"
                          );
                        },
                      },
                    }}
                    error={errors.date_of_birth?.message}
                  />
                  <DropDownInput
                    name="marital_status"
                    label="Marital Status"
                    options={[
                      { value: "single", label: "Single" },
                      { value: "married", label: "Married" },
                      { value: "divorced", label: "Divorced" },
                      { value: "widow", label: "Widow" },
                    ]}
                    registerOptions={{ required: "Marital Status is required" }}
                    error={errors.marital_status?.message}
                  />
                </div>
                <div className="form-row">
                  <FormInput
                    name="mobile"
                    label="Mobile"
                    type="tel"
                    registerOptions={validationRules.mobile}
                    error={
                      mobileExists
                        ? "Mobile number already exists"
                        : errors.mobile?.message
                    }
                  />
                  <FormInput
                    name="email"
                    label="E-mail"
                    //type="email"
                    registerOptions={validationRules.email}
                    error={errors.email?.message}
                  />
                </div>

                <div className="form-row">
                  <FormInput
                    name="address"
                    label="Address"
                    registerOptions={{ required: "Address is required" }}
                    error={errors.address?.message}
                  />
                  <SelectInput
                    name="city"
                    label="City"
                    options={cityOptions}
                    error={errors.city?.message}
                    registerOptions={{ required: "City is required" }}
                  />
                  <SelectInput
                    name="state"
                    label="State"
                    options={stateOptions}
                    registerOptions={{ required: "State is required" }}
                    error={errors.state?.message}
                  />
                  <SelectInput
                    name="pincode"
                    label="Pincode"
                    options={pincodeOptions}
                    registerOptions={{ required: "Pincode is required" }}
                    rules={{ required: "Pincode is required" }}
                  />
                </div>
              </div>
            )}
            {activeStep === 1 && (
              <div className="sections loan-details-sections">
                <div className="form-row">
                  <FormInput
                    name="occupation"
                    label="Occupation"
                    registerOptions={{ required: "Occupation is required" }}
                    error={errors.occupation?.message}
                  />
                  <DropDownInput
                    name="highest_education"
                    label="Highest Education"
                    options={[
                      { value: "University", label: "University" },
                      { value: "College", label: "College" },
                      { value: "Secondary", label: "Secondary" },
                      { value: "Primary", label: "Primary" },
                      { value: "Other", label: "Other" },
                    ]}
                    registerOptions={{
                      required: "Highest Education is required",
                    }}
                    error={errors.highest_education?.message}
                  />
                </div>
                <div className="form-row">
                  <DropDownInput
                    name="employee_type"
                    label="Employee Type"
                    options={[
                      { value: "salaried", label: "Salaried" },
                      { value: "self employed", label: "Self Employed" },
                    ]}
                    registerOptions={{ required: "Employee Type is required" }}
                  />
                  <DropDownInput
                    name="own_house"
                    label="Are you a homeowner, renter, or other?"
                    options={[
                      { value: "homeowner", label: "Homeowner" },
                      { value: "renter", label: "Renter" },
                      { value: "other", label: "Other" },
                    ]}
                    registerOptions={{
                      required: "Home Ownership status is required",
                    }}
                  />
                </div>
                <DropDownInput
                  name="insure_credit_card"
                  label="Already have a credit card?"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  registerOptions={{
                    required: "This question is required",
                  }}
                />
                {watch("insure_credit_card") === "yes" && (
                  <FormInput
                    name="credit_score"
                    label="Credit Card Limit"
                    type="number"
                    registerOptions={{
                      required: "Credit Card Limit",
                    }}
                    error={errors.credit_score?.message}
                  />
                )}
              </div>
            )}

            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    <div className="document-upload-group">
                      <label htmlFor="pan" className="document-label">
                        PAN Card
                      </label>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="pan"
                          className="form-control-file"
                          {...methods.register("pan")}
                          onChange={handleFileChange}
                        />
                        {/* <div className="file-name">{fileNames.pan}</div> */}
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <div className="document-label-container">
                        <label htmlFor="aadhar" className="document-label">
                          Aadhaar Card
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="aadhar"
                          className="form-control-file"
                          {...methods.register("aadhar")}
                          onChange={handleFileChange}
                        />
                        {/* <div className="file-name">{fileNames.aadhar}</div> */}
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <div className="document-label-container">
                        <label htmlFor="photo" className="document-label">
                          Photo
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="photo"
                          className="form-control-file"
                          {...methods.register("photo")}
                          onChange={handleFileChange}
                        />
                        {/* <div className="file-name">{fileNames.photo}</div> */}
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <div className="document-label-container">
                        <label
                          htmlFor="bank_account"
                          className="document-label"
                        >
                          SB/CA Account
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="bank_account"
                          className="form-control-file"
                          {...methods.register("bank_account")}
                          onChange={handleFileChange}
                        />
                        {/* <div className="file-name">{fileNames.bank_account}</div> */}
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <div className="document-label-container">
                        <label htmlFor="itr" className="document-label">
                          ITR
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="itr"
                          className="form-control-file"
                          {...methods.register("itr")}
                          onChange={handleFileChange}
                        />
                        {/* <div className="file-name">{fileNames.itr}</div> */}
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <div className="document-label-container">
                        <label htmlFor="gst_others" className="document-label">
                          GST & Others
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="gst_others"
                          className="form-control-file"
                          {...methods.register("gst_others")}
                          onChange={handleFileChange}
                        />
                        {/* <div className="file-name">{fileNames.gst_others}</div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 && (
                  <Button
                    type="submit"
                    variant="primary"
                    className="custom-submit-button"
                  >
                    Submit
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default CreateCreditCardForm;
